const { combineReducers } = require("redux");
const actions = require('./actions').default;
const { appState } = require('./appState');
const { screenState } = require('./screenState');
const { gameState } = require('./gameState');
const { selectorState } = require('./selectorState');
const { boardState } = require('./boardState');
const { playerState } = require('./playerState');
// ==============================

const reducer = combineReducers({ appState, screenState, gameState, selectorState, boardState, playerState });


export default { reducer, actions };